import { eventChannel, buffers } from 'redux-saga';
import { fork, all, take, put } from 'redux-saga/effects';
import { Url } from '@wix/da-url';
import ddt from '@wix/da-ddt';
import { appMounted } from '../../redux/app/actions';
import { messageReceived } from './action';
const logger = ddt.createLogger('sharedMessages');
function tryParseMessage(event) {
    const expectedOrigin = Url.origin();
    if (event.origin !== expectedOrigin) {
        logger.log('Invalid origin', event.origin);
        return;
    }
    let data;
    try {
        data = JSON.parse(event.data);
        if (!data.type) {
            logger.log('Missing message type', data);
            return;
        }
    } catch (e) {
        logger.log('Error parsing data', e, data);
        return;
    }
    return data;
}
function* handleAppMount() {
    yield take(appMounted);
    // event channels allow us to subscribe to an event source
    // that we can use with take() for listening to events
    const messageChannel = eventChannel((emitter)=>{
        window.addEventListener('message', emitter);
        return ()=>{
            window.removeEventListener('message', emitter);
        };
    }, // going absolutely safe here, never drop a message
    buffers.expanding());
    while(true){
        const event = yield take(messageChannel);
        logger.log('Got messageEvent: ', event);
        const message = tryParseMessage(event);
        if (!message) {
            continue;
        }
        logger.log('Message received', message);
        yield put(messageReceived(message));
    }
}
export default function* saga() {
    yield all([
        fork(handleAppMount)
    ]);
}
